import PaperError from '@errors/PaperError';

export const NAME = 'PaymentError';

export default class PaymentError extends PaperError {
    public constructor(message = '') {
        super(message, NAME);
    }
}
